import plansContentPackage from '@mentimeter/plans-content/locales';
import { locales as authLocales } from '@mentimeter/auth';
import { locales as votingBarLocales } from '@mentimeter/voting-bar';
import enUsCommon from './en-US/common.json';
import deDeCommon from './de-DE/common.json';
import esEsCommon from './es-ES/common.json';
import ptBrCommon from './pt-BR/common.json';

export interface LocalesT {
  [key: string]: any;
}

const locales = {
  'en-US': {
    common: enUsCommon,
    authPackage: authLocales['en-US'].authPackage,
    votingBarPackage: votingBarLocales['en-US'].votingBarPackage,
    ...plansContentPackage['en-US'],
  },
  'pt-BR': {
    common: ptBrCommon,
    authPackage: authLocales['pt-BR'].authPackage,
    votingBarPackage: votingBarLocales['pt-BR'].votingBarPackage,
    ...plansContentPackage['pt-BR'],
  },
  'es-ES': {
    common: esEsCommon,
    authPackage: authLocales['es-ES'].authPackage,
    votingBarPackage: votingBarLocales['es-ES'].votingBarPackage,
    ...plansContentPackage['es-ES'],
  },
  'de-DE': {
    common: deDeCommon,
    authPackage: authLocales['de-DE'].authPackage,
    votingBarPackage: votingBarLocales['de-DE'].votingBarPackage,
    ...plansContentPackage['de-DE'],
  },
};

type LegacyLocalesKeys = keyof typeof locales;
type LegacyMessages = (typeof locales)['en-US'];
export { locales, type LegacyLocalesKeys, type LegacyMessages };
